export const isEnvDev = (process.env.NODE_ENV === "development") ? true : false;

export default {
  isEnvDev
}